export default {
    closed: "Clase en vivo cerrada",
    do_you_confirm_your_registration_for_the_live_class: "¿Confirma su registro para la clase en vivo {title}?",
    do_you_confirm_your_unsubscription_to_the_live_class: "¿Confirmas tu baja la clase en vivo {title}?",
    live_class_closed: "Clase en vivo cerrada",
    live_class_offline: "Clase en vivo sin conexión",
    live_class_opened: "Clase en vivo abierta",
    live: "En vivo",
    loading_live_classes: "Cargando clases en vivo",
    next: "Próxima",
    no_live_classes_are_available_at_the_moment: "Actualmente no hay clases en vivo disponibles",
    no_live_classes_are_available_with_the_selected_filter: "No hay clases en vivo disponibles para el filtro seleccionado.",
    no_vacancy: "Agotado",
    opened: "Clase en vivo abierta",
    please_wait_the_class_will_start_automatically: "Espere por favor. Pronto te unirás a la sala.",
    receive_emails_about_this_live_class: "Reciba correos electrónicos sobre este clase en vivo",
    register_for_the_live_class: "Regístrese para la clase en vivo",
    subscribe: "Registrarse",
    subscribed: "Registrado",
    successfully_signed_up_for_the_live_class: "Se inscribió con éxito en la clase en vivo",
    this_class_has_ended: "Esta clase ha terminado",
    transmission_date: "Fecha de transmisión",
    transmission_finished: "Transmisión terminada",
    unsubscribe_from_the_live_class: "Cancelar inscripción de la clase en vivo",
    unsubscribe_successfully_for_the_live_class: "Cancelar inscripción con éxito para la clase en vivo",
    unsubscribe: "Cancelar inscripción",
    your_live_class_will_start_soon_please_wait: "Su clase en vivo comenzará pronto, por favor espere",
    this_reaction_assessment_will_only_be_unlocked_after_completing_all_activities_in_this_module: "Esta evaluación de reacción solo se desbloqueará después de completar todas las actividades de este módulo.",
    this_activity_will_only_be_unlocked_after_the_live_class_instructors_authorization: "Esta actividad solo se desbloqueará después de la autorización del instructor de la clase en vivo."
}